import { apiClient } from "../apiClient";

export const heApi = {
    getAll: () => apiClient.get(`he`)
}